import React from 'react';
import ReactDOM from 'react-dom';
import LibraryApp from '../src/library/index'
/* global photoOrg */
const loadLibraryModule = ({selector,config}) => {
  const selectorElement = document.querySelector(selector)
  ReactDOM.unmountComponentAtNode(selectorElement); 

  console.log("unmounted the div and mounting again");
  ReactDOM.render(
      <LibraryApp rid="LibraryApp" selector={selector} config={config}></LibraryApp>,
    selectorElement
  )
}

photoOrg.loadLibraryModule = loadLibraryModule;